import { format } from "date-fns";

export const VENDOR_COLUMNS = [
  {
    Header: "Vendor No",
    accessor: "VendorNo"
  },
  {
    Header: "Name",
    accessor: "Name"
  },
  {
    Header: "Active",
    accessor: "Active",
    Cell: ({ cell }) => (cell.value ? "Yes" : "No")
  },
  {
    Header: "Address 1",
    accessor: "Address1"
  },
  {
    Header: "Address 2",
    accessor: "Address2"
  },
  {
    Header: "City",
    accessor: "City"
  },
  {
    Header: "State",
    accessor: "State"
  },
  {
    Header: "Zip",
    accessor: "Zip"
  },
  {
    Header: "Contact",
    accessor: "Contact"
  },
  {
    Header: "Telephone",
    accessor: "Telephone"
  },
  {
    Header: "Fax",
    accessor: "Fax"
  },
  {
    Header: "Email",
    accessor: "EmailAddr"
  },
  {
    Header: "Website",
    accessor: "WebSite"
  },
  {
    Header: "Last Transaction Date",
    accessor: "LastTransactionDate",
    Cell: ({ cell }) => {
      const { value } = cell;
      if (value !== null && typeof value !== "undefined") {
        const date = new Date(value)
          .toISOString()
          .substr(0, 10)
          .split("-");
        return format(
          new Date(date[0], parseInt(date[1]) - 1, date[2]),
          "MM/dd/yyyy"
        );
      }
      return "N/A";
    }
  }
];
